import {
	SupervisorActions,
	useSupervisorStore,
} from "@/common/stores/nonpersistingStores/supervisor";
import { useAuth } from "@/hooks/authentication";
import { useEffect } from "react";
import { ServerEvent } from "@/common/notification";
import { notificationListener } from "@/hooks/notification";
import { checkAgentIfSupervisor } from "@/repository/queryFns/supervisor";
import { Lockr } from "@/common/Lockr";
import { StorageKeys } from "@/common/constants/storageKeys";

export const useSupervisorManager = () => {
	const authContext = useAuth();
	const supervisorActions = useSupervisorStore(
		(actions: SupervisorActions) => actions
	);

	const updateSupervisorStatus = () => {
		const agentId = Lockr.get(StorageKeys.UserId);

		if (agentId) {
			checkAgentIfSupervisor(agentId).then(supervisorActions.update);
		}
	};

	useEffect(() => {
		if (!authContext.isLogged) {
			return;
		}

		updateSupervisorStatus();
	}, [authContext.isLogged]);

	notificationListener(ServerEvent.SupervisorAgentsUpdated, (_: any) => {
		updateSupervisorStatus();
	});

	notificationListener(ServerEvent.UserPermisionChanged, (_: any) => {
		updateSupervisorStatus();
	});
};
